import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';

@Component({
  selector: 'app-generate-popup',
  templateUrl: './generate-popup.component.html',
  styleUrls: ['./generate-popup.component.scss']
})
export class GeneratePopupComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;

  myshipForm!: FormGroup;
  fileUploaded: boolean = false;
  uploadedFile!: File;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private commonService: CargoheatingCommonService,
    public dialogRef: MatDialogRef<GeneratePopupComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public mainFormData: any   // <-- MAIN FORM DATA HERE
  ) { }

  ngOnInit() {
    // 1️⃣ Initialize form with empty arrays
    this.myshipForm = this.fb.group({
      load_ports: this.fb.array([]),
      discharge_ports: this.fb.array([])
    });

    // 2️⃣ Populate load ports from mainFormData if available
    if (this.mainFormData?.load_ports?.length) {
      this.mainFormData.load_ports.forEach((port: any, index: number) => {
        this.loadPorts.push(this.createPortRowFromData(port, index + 1));
      });
    } else {
      this.loadPorts.push(this.createPortRow(1)); // default row if no data
    }

    // 3️⃣ Populate discharge ports from mainFormData if available
    if (this.mainFormData?.discharge_ports?.length) {
      this.mainFormData.discharge_ports.forEach((port: any, index: number) => {
        this.dischargePorts.push(this.createPortRowFromData(port, index + 1));
      });
    } else {
      this.dischargePorts.push(this.createPortRow(1)); // default row if no data
    }
  }
  createPortRowFromData(port: any, sequence: number): FormGroup {
    return this.fb.group({
      port_sequence: [sequence],
      port_name: [port.port_name || '', Validators.required],
      events: this.fb.group({
        eospDate: [port.events?.eospDate || ''],
        eospHours: [port.events?.eospHours || ''],
        eospMinutes: [port.events?.eospMinutes || ''],

        all_fastDate: [port.events?.all_fastDate || ''],
        all_fastHours: [port.events?.all_fastHours || ''],
        all_fastMinutes: [port.events?.all_fastMinutes || ''],

        cospDate: [port.events?.cospDate || ''],
        cospHours: [port.events?.cospHours || ''],
        cospMinutes: [port.events?.cospMinutes || ''],
      })
    });
  }


  createPortRow(sequence: number): FormGroup {
    return this.fb.group({
      port_sequence: [sequence],
      port_name: ['', Validators.required],
      events: this.fb.group({
        eospDate: [''],
        eospHours: [''],
        eospMinutes: [''],

        all_fastDate: [''],
        all_fastHours: [''],
        all_fastMinutes: [''],

        cospDate: [''],
        cospHours: [''],
        cospMinutes: [''],
      })
    });
  }

  get loadPorts(): FormArray {
    return this.myshipForm.get('load_ports') as FormArray;
  }

  get dischargePorts(): FormArray {
    return this.myshipForm.get('discharge_ports') as FormArray;
  }

  addLoadPort() {
    this.loadPorts.push(this.createPortRow(this.loadPorts.length + 1));
  }

  removeLoadPort(i: number) {
    if (this.loadPorts.length > 1) this.loadPorts.removeAt(i);
  }

  addDischargePort() {
    this.dischargePorts.push(this.createPortRow(this.dischargePorts.length + 1));
  }

  removeDischargePort(i: number) {
    if (this.dischargePorts.length > 1) this.dischargePorts.removeAt(i);
  }

  restrictInput(target: any, maxValue: number) {
    if (target.value > maxValue) target.value = maxValue;
    if (target.value < 0) target.value = 0;
  }

  uploadFile(event: any) {
    const file = event.target.files?.[0];
    if (file) {
      this.uploadedFile = file;
      this.fileUploaded = true;
    }
  }

  mergeEvent(event: any) {
    return {
      eosp: `${this.formatDate(event.eospDate)} ${event.eospHours}:${event.eospMinutes}`,
      all_fast: `${this.formatDate(event.all_fastDate)} ${event.all_fastHours}:${event.all_fastMinutes}`,
      cosp: `${this.formatDate(event.cospDate)} ${event.cospHours}:${event.cospMinutes}`,
    };
  }

  formatDate(date: string) {
    if (!date) return "";
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1)
      .toString().padStart(2, '0')}-${d.getFullYear()}`;
  }


  //  createFinalReport() {

  //   if (!this.uploadedFile) {
  //     this.toastr.error("Please upload file first");
  //     return;
  //   }

  //   const popupValue = this.myshipForm.value;

  //   const loadPortsPayload = popupValue.load_ports.map((p: any) => ({
  //     port_sequence: p.port_sequence,
  //     port_name: p.port_name,
  //     events: this.mergeEvent(p.events)
  //   }));

  //   const dischargePortsPayload = popupValue.discharge_ports.map((p: any) => ({
  //     port_sequence: p.port_sequence,
  //     port_name: p.port_name,
  //     events: this.mergeEvent(p.events)
  //   }));

  //   const finalPayload: any = {
  //     ...this.mainFormData,
  //     load_ports: loadPortsPayload,
  //     discharge_ports: dischargePortsPayload,
  //   };

  //   console.log("FINAL PAYLOAD 👉", finalPayload);

  //   const formData = new FormData();

  //   // 🔥 FIX: API expects "json_data" key
  //   formData.append("json_data", JSON.stringify(finalPayload));

  //   // If file is required:
  //   formData.append("file", this.uploadedFile);

  //   this.commonService.generateFinalReport(formData).subscribe({
  //     next: () => {
  //       this.toastr.success("Final report generated!");
  //       this.dialogRef.close();
  //     },
  //     error: () => this.toastr.error("Something went wrong")
  //   });
  // }
  createFinalReport() {
    if (!this.uploadedFile) {
      this.toastr.error("Please upload file first");
      return;
    }

    const popupValue = this.myshipForm.value;

    const loadPortsPayload = popupValue.load_ports.map((p: any) => ({
      port_sequence: p.port_sequence,
      port_name: p.port_name,
      events: this.mergeEvent(p.events)
    }));

    const dischargePortsPayload = popupValue.discharge_ports.map((p: any) => ({
      port_sequence: p.port_sequence,
      port_name: p.port_name,
      events: this.mergeEvent(p.events)
    }));

    const finalPayload: any = {
      ...this.mainFormData,
      load_ports: loadPortsPayload,
      discharge_ports: dischargePortsPayload,
    };

    console.log("FINAL PAYLOAD 👉", finalPayload);

    const formData = new FormData();
    formData.append("json_data", JSON.stringify(finalPayload));
    formData.append("file", this.uploadedFile);

    this.commonService.generateFinalReport(formData).subscribe({
      next: () => {
        this.toastr.success("Final report generated!");

        // Optional: reset the form if you want
        this.myshipForm.reset();
        this.loadPorts.clear();
        this.dischargePorts.clear();
        this.loadPorts.push(this.createPortRow(1));
        this.dischargePorts.push(this.createPortRow(1));
        // this.uploadedFile = undefined;
        this.fileUploaded = false;
        if (this.fileInput) this.fileInput.nativeElement.value = '';

     
        this.dialogRef.close(); 
        this.router.navigate(['/ch-finalReport']); // <-- replace '/cgraph' with your target route
      },
      error: () => this.toastr.error("Something went wrong")
    });
  }


  closeModal() {
    this.dialogRef.close();
  }

  clearClick() { }
}
